import React, { Fragment, PureComponent } from 'react';
import _ from 'lodash';
import { Trans } from 'react-i18next';
import { withTheme } from 'styled-components';
import loadable from '@loadable/component';

import { capfl } from 'common/utils';

const Row = loadable(() => import('common/components/styleguide/grid/Row'));
const Column = loadable(() =>
  import('common/components/styleguide/grid/Column')
);

const Alert = loadable(() => import('common/components/styleguide/Alert'));
const Emoji = loadable(() => import('common/components/styleguide/Emoji'));
import { Headline6 } from 'common/components/styleguide/Headline';

import Price from 'common/components/_base/Price';

import { formatPrice } from 'common/utils';

class ProductPriceVariant3 extends PureComponent {
  render() {
    const { product, isLocked, theme, showAlert = true, t } = this.props;
    const {
      finalPriceData = {},
      // priceData,
      // retailPriceData,
      standardPriceData = {},
      finalPrice,
      finalPriceWithoutDPH,
      specialPrice,
      measureUnit,
      discount,
      name,
    } = product;

    if (isLocked) {
      return (
        <Alert type={'danger'}>
          <Emoji label={t('restricted area')}>👮</Emoji>{' '}
          {capfl(t('this content is locked!'))}
        </Alert>
      );
    }

    const showOldPrice =
      _.get(finalPriceData, 'price', 0) < _.get(standardPriceData, 'price', 0);
    const priceDifference = showOldPrice
      ? formatPrice(
          _.get(standardPriceData, 'price', 0) -
            _.get(finalPriceData, 'price', 0)
        )
      : 0;
    const currencySymbol = _.get(finalPriceData, 'currencySymbol', '');

    return (
      <Fragment>
        {showOldPrice && priceDifference && showAlert ? (
          <Alert type={'danger'}>
            <Trans
              i18nKey="productDiscoutBlockPriceVariant3Part1"
            >
              <Emoji label={t('discount')}>🎉</Emoji> SAVE <strong>{{ discount }}</strong>
            </Trans>{' '}
            <Trans
              i18nKey="productDiscoutBlockPriceVariant3Part2"
            >
              Better price by <strong> {{ priceDifference }} {{ currencySymbol }}</strong> from original price
            </Trans>
          </Alert>
        ) : (
          ''
        )}
        <Row>
          <Column size={{ xs: showOldPrice ? 6 : 12 }}>
            <Headline6>{capfl(t('internet price'))}</Headline6>
            <Price
              isInline={true}
              finalPrice={
                !_.isEmpty(finalPriceData)
                  ? finalPriceData.priceFormatted
                  : finalPrice
              }
              finalPriceWithoutDPH={
                !_.isEmpty(finalPriceData)
                  ? finalPriceData.priceWithoutVatFormatted
                  : finalPriceWithoutDPH
              }
              measureUnit={measureUnit}
              showDiscount={false}
              showWithoutVat={true}
              useFormatPrice={!_.isEmpty(finalPriceData) ? false : true}
              useFormatDiscount={false}
              useCurrencySymbol={!_.isEmpty(finalPriceData) ? false : true}
              customStyle={{
                finalPrice: {
                  fontSize: '1.75em',
                  fontWeight: 'bolder',
                  color: showOldPrice
                    ? _.get(theme, 'colors.danger')
                    : _.get(theme, 'colors.text'),
                },
                finalPriceWithoutVAT: {
                  fontSize: '0.8em',
                  color: showOldPrice
                    ? _.get(theme, 'colors.danger')
                    : _.get(theme, 'colors.text'),
                },
              }}
            />
          </Column>
          {showOldPrice ? (
            <Column size={{ xs: 6 }}>
              <Headline6 color={'gray'}>{capfl(t('original price'))}</Headline6>
              <div style={{ textDecoration: 'line-through', opacity: 0.7 }}>
                <Price
                  isInline={true}
                  finalPrice={
                    !_.isEmpty(standardPriceData)
                      ? standardPriceData.priceFormatted
                      : finalPrice
                  }
                  finalPriceWithoutDPH={
                    !_.isEmpty(standardPriceData)
                      ? standardPriceData.priceWithoutVatFormatted
                      : finalPriceWithoutDPH
                  }
                  measureUnit={measureUnit}
                  showDiscount={false}
                  showWithoutVat={false}
                  useFormatPrice={!_.isEmpty(standardPriceData) ? false : true}
                  useFormatDiscount={false}
                  useCurrencySymbol={
                    !_.isEmpty(standardPriceData) ? false : true
                  }
                  customStyle={{
                    finalPrice: {
                      fontSize: '1.75em',
                      fontWeight: 'bolder',
                      color: _.get(theme, 'colors.lgray'),
                    }
                  }}
                />
              </div>
            </Column>
          ) : null}
        </Row>
      </Fragment>
    );
  }
}

export default withTheme(ProductPriceVariant3);
